/**
 * TODO (Tech debt): Validação isInteger necessária por um débito técnico,
 * onde o campo de amount do plano, pode estar vindo em um formato inteiro.
 * */
export default function FloatToCurrency(value) {
  let number = parseFloat(value);

  return number.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
